import type { Components, Theme } from "@mui/material";

export const filledInputTheme: Components<Theme>["MuiFilledInput"] = {
  styleOverrides: {
    root: ({ theme }) => ({
      borderRadius: theme.borderRadius.md,
      backgroundColor: theme.palette.custom.fillSecondary,
      padding: theme.spacing(0),
      minHeight: "40px",
      "&:hover": {
        backgroundColor: theme.palette.custom.fillSecondaryHover,
      },
      "&.Mui-focused": {
        backgroundColor: theme.palette.custom.fillSecondary,
      },
      "&.Mui-disabled": {
        opacity: theme.opacity.disabled,
        backgroundColor: theme.palette.custom.fillSecondary,
      },
      "& .MuiSelect-icon": {
        right: "14px",
      },
      "& .MuiSelect-select": {
        paddingRight: "38px !important",
      },
      variants: [
        {
          props: { size: "small" },
          style: {
            borderRadius: theme.borderRadius.sm,
            minHeight: "32px",
            "& .MuiSelect-icon": { right: "8px" },
            "& .MuiSelect-select": {
              paddingRight: "30px !important",
            },
          },
        },
        {
          props: { size: "large" },
          style: {
            borderRadius: theme.borderRadius.lg,
            minHeight: "48px",
            "& .MuiSelect-icon": { right: "20px" },
            "& .MuiSelect-select": {
              paddingRight: "44px !important",
            },
          },
        },
      ],
    }),
    input: ({ theme }) => ({
      padding: "8px 16px",
      fontSize: 14,
      variants: [
        {
          props: { size: "small" },
          style: { padding: "4px 12px", fontSize: 13 },
        },
        {
          props: { size: "large" },
          style: { padding: "12px 24px", fontSize: 14 },
        },
      ],
    }),
  },
};
